import Vue from 'vue'

import translates from './plugins/translates'

Vue.use(translates, {
  keys: ['header', 'footer', 'global', 'meta', 'calendar', 'vacancies', 'auth', 'vacancy', 'vacancyHint', 'newVacancy', 'filter', 'schedule_types', 'resume', 'received',
    'profile', 'month', 'mailing', 'myVacancy', 'myResponses', 'myVacancyHint', 'company', 'address', 'home', 'news', 'help', 'employer', 'addResume', 'myResumes', 'Cooperation', 'sidebar', 'siteMap',
    'cookie', 'newVacancy2', 'addResume2', 'resumeList', 'vacancyEditHint', 'interaction', 'resumeCard', 'partners', 'dossier', 'account', 'settings', 'about', 'services', 'credits', 'creditsGet', 'legalServices', 'legalServicesRequestSent', 'resumePage', 'payment', 'moderatorCandidates',
    'modalsAuto',
    'employersLT',
    'findVacancy',
    'moderatorMarketing',
    'moderatorMarketingTesting',
    'employerProfileForm',
    'resumesBase',
    'resumesBaseResumes',
    'resumesBaseInviteModal',
    'resumesBaseInteraction',
    'partnersRegisterPopup',
    'partnersRegisteredPopup',
    'partnersRegisteredChangePopup',
    'authAgentLogin',
    'authEmployerLogin',
    'authEmployerRegister',
    'statistic',
    'employerVacancies',
    'employerProfileForm',
    'accountProfileChangePassword',
    'candidateForm',
    'accountSubscription',
    'additionalQuestionsResponses',
    'employerPoland',
  ]
})
